import { Create } from "react-admin";
import { DiscountTabbedForm } from "./DiscountTabbedForm";

export const DiscountCreate = (props) => (
  <Create title="Criação de Desconto" {...props}>
    <DiscountTabbedForm {...props} />
  </Create>
);
